<template>
  <div v-if="plate">
    <v-checkbox
      label="PERFECT! The system is building you a plan. If we find something you
        like, I can help set it up."
      v-model="plate.isHelpAsked"
      :error="$v.plate.isHelpAsked.$error"
    />

    <v-checkbox
      label="It looks like you qualify for one of the best companies! They're A rated excellent."
      v-model="plate.isQualifyAsked"
      :error="$v.plate.isQualifyAsked.$error"
    />

    <v-checkbox
      label="Them being A rated means that if all their policy holders passed away..
        they have enough money to pay out all the policies and still stay in business
        to protect future families. Does that make sense?"
      v-model="plate.isCompanyRatingAsked"
      :error="$v.plate.isCompanyRatingAsked.$error"
    />

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import { format } from 'date-fns';
import { PlatesSteps } from '@/common/variables';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { isChecked } from '@/common/helpers';

export default {
  name: 'CompanyPlate',
  components: {
    PlateFooter,
  },
  props: {
    agent: {
      type: Object,
    },
    lead: {
      type: Object,
    },
  },
  data: () => ({
    plate: null,
    isLoading: false,
  }),
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.company
    );
    this.plate = data;
  },
  methods: {
    format,
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.generalHealth);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('plates/setStep', PlatesSteps.product);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
  validations: {
    plate: {
      isHelpAsked: {
        checked: isChecked,
      },
      isQualifyAsked: {
        checked: isChecked,
      },
      isCompanyRatingAsked: {
        checked: isChecked,
      },
    },
  },
};
</script>